import React from 'react';
import { withRouter } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import './faq.scss';

import LandingLayout from 'component/page/landing';
import { SectionTitle, ParaTitle } from 'component/reuse/title';
import {ModalFeedback} from 'component/reuse/modal';


class SearchForm extends React.Component {

  render (){
    return (
      <div className="form-group">
        <div className="input-group">
          <input onChange={this.props.onInputChange } className="form-control" type="text" placeholder="search ... " />
          <div className="input-group-append">
            <span className="input-group-text bg-success text-white"><i className="fa fa-search"></i></span>
          </div>

        </div>
      </div>
    )
  }
}

class Page extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      selected_hash: this.props.location.hash,
      search_text: null,
    }
  }

  onInputChange(e){
    e.preventDefault();
    const state = this.state;
    state.search_text = e.target.value;
    this.setState(state);
  }

  render (){

    const categories = {
      BLANK: '',
      
      GETTING_STARTED: 'Getting Started',
      ACCOUNTS: 'Account',
      LIMITATIONS: 'Limitations',
      USE_CASES: 'Features',
      TROUBLESHOOTING: 'Troubleshooting',
      BILLING: 'Paid memberships and purchases',
      ANALYTICS: 'Analytics and Reports',
      
    }

    const getting_started = {
      'type': categories.GETTING_STARTED,
      'questions': [
        {
          'id': 'first-show',
          'question': 'How do I record my first show?',
          'answer': [
            'There are 3 main steps to get your first show',
            
            '<b class="text-spacing-2">Step 1 ( <1 sec)</b>',
            ' Create a site API on our platform by adding your website url',
            
            '<b class="text-spacing-2">Step 2 ( ~5 mins)</b>',
            ' We give you a divshow_builder script tag that you can add to BUILD your show on your localhost or test site (we recommend in hte HEAD section, but you can add anywhere in the HTML tag). Adding this tag will ask for audio permissions and show a control button near the bottom right corner of the screen. You can use the control button to record, replay and save your shows. Once you save the show we generate a show_id that you can view and edit on the DivShow website.',
            
            '<b class="text-spacing-2">Step 3 ( ~30 seconds)</b>',
            ' We now have a new divshow script tag ready for you to PLAY the show. Include this new tag on your website and create the trigger to start the show. Push the changes live and you\'ll have your shows running on your site.',

            'For more details please login and view the <a href="/instructions">instructions page</a>.',
          ],
        },
        {
          'id': 'stop-control',
          'question': 'Can the shows be stopped?',
          'answer': [
            'Yes. When you play a show a presentation banner pops up near the bottom. It has a "Stop Show" button to stop the running presentation'
          ],
        },
        {
          'id': 'extended-controls',
          'question': 'Are other controls like pause, rewind, forward etc supported?',
          'answer': [
            'No. We want users to start thinking differently from traditional videos. The intention for DivShow is to keep shows really short so there is a clear focus of what is being communicated to the user and no need to place larger cognitive load on the end user to be thinking about pausing and consuming information before moving forward again.'
          ],
        },
        {
          'id': 'multi-shows',
          'question': 'Can I run multiple shows on the same page?',
          'answer': [
            'Absolutely! We encourage users to build small shows as the content and relevance is to the point. These are also easy to update as you make modifications on your website. Becuse of this recommendation we expect users will have multiple shows running on the same page.'
          ],
        },
      ]
    }
    const limitations = {
      'type': categories.LIMITATIONS,
      'questions': [
        {
          'id': 'page-loads',
          'question': 'Can DivShow work between page loads?',
          'answer': [
            'No. We encourage service owners to talk about what\'s infront of their users. Navigating to a new page means a new shows for that page.'
          ],
        },
        {
          'id': 'multi-device',
          'question': 'Do shows work on all devices?',
          'answer': [
            'Shows recorded on a device are for that specific device. They don\'t cross a "device boundary" yet. If your site layout doesn\'t change much your show will work just fine. However, if your layout changes significantly for each device, then you\'ll have to record the same show for the different layouts you support.', 
            'Moreover, given shows are meant to be short, they rarely cross a section boundary. This means the change in layout that spans a show is small and might not need a re-recording. ',
            '<a href="/login">Give DivShow a try</a> and test this out yourself!',
          ],
        },
        {
          'id': 'layout-change',
          'question': 'What happens to my show if I change the layout of my website?',
          'answer': [
            'It depends! If the changes are minor, your show may still work on the same page. Stylistic changes will have no impact on the show. Structural changes might have an impact, but the good news here is you can test out if the show works in test mode and if the structural changes are large enough, then record a new show for the new layout. ', 
            'We can provide support in case you wish to keep the audio for your show, but want to update the mouse movements. However in most cases, users prefer to just record the show again. It\'s not only faster, but the correct path to take in most cases, because structural changes typically mean new information added into the audio flow.',
          ],
        },
      ]
    }
    const use_cases = {
      'type': categories.USE_CASES,
      'questions': [
        {
          'id': 'custom-divshow',
          'question': 'Can DivShow help my users record shows on how they use my service?',
          'answer': [
            'Yes! Just get in touch with us and we\'ll help you push the show builder to your live site that allows your users to easily record their issues and report them back to you for further analysis.'
          ],
        },
        {
          'id': 'captions',
          'question': 'Will captioning be available for recorded shows?',
          'answer': [
            'This feature is on our todo list. Unfortunately we don\'t have a timeline available for its release this yet.'
          ],
        },
      ]
    }
    const troubleshooting = {
      'type': categories.TROUBLESHOOTING,
      'questions': [
        {
          'id': 'not-playing',
          'question': 'My shows aren\'t playing. What\'s going on?',
          'answer': [
            'Our shows don\'t work on some browsers (e.g Safari ) and don\'t play well with some tracker blocking plugins (eg: Ghostery). We\'re working on trying to get these issues resolved soon.'
          ],
        },
        {
          'id': 'builder-not-showing-up',
          'question': 'You added the builder script on your page, but the control button is not showing up. What\' going on?',
          'answer': [
            'We recommend you build your show on localhost / locally andn push the player code live. ',
            'However sometimes our customers prefer pushing the builder script live to their site as well. In this case you have to make sure the page is served over <strong>https</strong>. ',
            "If you're still experiencing issues feel free to contact us on info@bytebeacon.com ",
          ],
        },
      ]
    }

    const question_categories = [
      getting_started,
      limitations,
      use_cases,
      troubleshooting,
    ]
  
    const search_text = this.state.search_text;

    return (
      <LandingLayout id="faq-page">   

        <div className="flex-center">
          <div className="m-3 content-section container">
            <SectionTitle first="Frequently asked" second="Questions" flip={false} background={"quaternary"} />

            <div className="container">
              <div className="my-5">
                <SearchForm onInputChange={this.onInputChange.bind(this)}  />
              </div>

              {question_categories.map(function(category, idx){
                return (
                  <div className="my-4" key={"k_"+idx}>
                    <div className="highlight-quaternary-2 p-2 mt-5 btn-rounded">
                    <ParaTitle first={category.type} />
                    </div>

                    {category.questions.map(function(q, idx){
                      var search_str_data = q.question.toLowerCase() + ' ' + category.type.toLowerCase();
                      for (var i = 0; i < q.answer.length; i++){
                        search_str_data = search_str_data + q.answer[i].toLowerCase();
                      }

                      const show = (search_str_data.includes(search_text) || search_text === null);

                      if (!show){return (<div className="" key={"k_"+idx}></div>)}
                      const collapse = !(this.state.selected_hash === '' || this.state.selected_hash === "#" + q.id);

                      return(
                        <div className="my-4" key={"k_"+idx} id={q.id}>
                          <Question Q={q.question} A={q.answer} collapse={collapse}/>
                        </div>
                      )
                    }, this)}

                  </div>
                )                
              }, this)}

            </div>     
          </div>
          <div className="">
            <ModalFeedback modalLinkText={"Have another question?"} modalID={"faq_feedback"} modalTitle={"FAQ"} />
          </div>

        </div>

      </LandingLayout>
    )
  }
}

function Question(props){

  if (props.A === undefined){
    return '';
  }

  const open = !props.collapse;

  return (
    <Collapsible trigger={props.Q} open={open} >
      {props.A.map(function(line, idx){
        return (
          <p key={"k_"+idx} dangerouslySetInnerHTML={{__html: line }}></p>
        )
      })}
    </Collapsible>
  )
}

export default withRouter(Page);